import { FC } from 'react'
import { Navigate } from 'react-router-dom'
import { AuthService } from '../../interactors/services/AuthService'
import { DashboardStructure } from '../DashboardStructure'

export const PrivateRoutes: FC = () => {
  return AuthService.isLogged() ? <DashboardStructure /> : <Navigate to="/login" />
}
